import { useEffect, useMemo, useState } from "react";

/** Last slide index when showing `slidesToShow` items at once (infinite: false). */
export function getSlickMaxIndex(itemCount, slidesToShow) {
  const slides = Math.max(1, Number(slidesToShow) || 1);
  const count = Math.max(0, Number(itemCount) || 0);
  return Math.max(0, count - slides);
}

/**
 * Desktop header arrows for react-slick (infinite: false).
 * Spread `slickArrowEvents` onto Slider settings.
 */
export default function useSlickArrows(itemCount, slidesToShow, resetKey) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
  }, [itemCount, slidesToShow, resetKey]);

  const maxIndex = useMemo(
    () => getSlickMaxIndex(itemCount, slidesToShow),
    [itemCount, slidesToShow]
  );

  const canPrev = index > 0;
  const canNext = index < maxIndex;
  const hasOverflow = maxIndex > 0;

  const slickArrowEvents = useMemo(
    () => ({
      beforeChange: (_current, next) => setIndex(next),
      afterChange: (current) => setIndex(current),
      onInit: () => setIndex(0),
      reInit: () => setIndex(0),
    }),
    []
  );

  return { canPrev, canNext, hasOverflow, slickArrowEvents, slideIndex: index };
}
